module.exports = __webpack_public_path__ + "img/63.e8c86a6c.png";